// frontend/src/utils/formatUtils.js

/**
 * Formatea un número con separador de miles
 * @param {number} number - Número a formatear
 * @param {number} decimals - Número de decimales (por defecto 2)
 * @returns {string} Número formateado
 */
export const formatNumber = (number, decimals = 2) => {
    if (number === null || number === undefined || isNaN(number)) {
      return '-';
    }
    
    return Number(number).toLocaleString('es-PE', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  };
  
  /**
   * Formatea un valor monetario
   * @param {number} value - Valor a formatear
   * @param {string} currency - Símbolo de moneda (por defecto 'S/')
   * @returns {string} Valor formateado con símbolo de moneda
   */
  export const formatCurrency = (value, currency = 'S/') => {
    if (value === null || value === undefined || isNaN(value)) {
      return '-';
    }
    
    return `${currency} ${formatNumber(value, 2)}`;
  };
  
  /**
   * Formatea texto para mostrar un valor por defecto si está vacío
   * @param {string} text - Texto a formatear
   * @param {string} defaultText - Texto por defecto (por defecto 'No registrado')
   * @returns {string} Texto original o texto por defecto
   */
  export const formatText = (text, defaultText = 'No registrado') => {
    if (!text || text.trim() === '') {
      return defaultText;
    }
    
    return text;
  };
  
  /**
   * Trunca un texto largo a una longitud máxima
   * @param {string} text - Texto a truncar
   * @param {number} maxLength - Longitud máxima (por defecto 100)
   * @returns {string} Texto truncado con puntos suspensivos
   */
  export const truncateText = (text, maxLength = 100) => {
    if (!text) return '';
    
    if (text.length <= maxLength) {
      return text;
    }
    
    return text.substring(0, maxLength) + '...';
  };
  
  /**
   * Formatea un mensaje de error para mostrarlo de forma consistente
   * @param {Error|string} error - Error a formatear
   * @returns {string} Mensaje de error formateado
   */
  export const formatErrorMessage = (error) => {
    if (!error) {
      return 'Error desconocido';
    }
    
    if (typeof error === 'string') {
      return error;
    }
    
    if (error.response && error.response.data && error.response.data.message) {
      return error.response.data.message;
    }
    
    if (error.message) {
      return error.message;
    }
    
    return 'Error desconocido';
  };
  
  /**
   * Capitaliza la primera letra de un texto
   * @param {string} text - Texto a capitalizar
   * @returns {string} Texto con la primera letra en mayúscula
   */
  export const capitalizeFirstLetter = (text) => {
    if (!text) return '';
    
    return text.charAt(0).toUpperCase() + text.slice(1);
  };
  
  /**
   * Formatea un nombre completo a partir de nombres y apellidos
   * @param {string} nombres - Nombres
   * @param {string} apellidos - Apellidos
   * @returns {string} Nombre completo formateado
   */
  export const formatFullName = (nombres, apellidos) => {
    if (!nombres && !apellidos) return '';
    
    if (!nombres) return apellidos;
    if (!apellidos) return nombres;
    
    return `${nombres} ${apellidos}`;
  };